import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

interface SectionTitleProps {
  mt?: boolean;
}

export default styled.h1<SectionTitleProps>`
  font-size: 24px;
  font-weight: 300;
  color: #ffffff;
  text-align: left;
  margin: 0;
  margin-bottom: 20px;
  padding: 0;

  @media screen and (min-width: ${DESKTOP}px) {
    font-size: 56px;
    margin-top: ${({ mt }) => mt && "40px"};
  }
`;
